import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import SiteMapComponent from '@components/sitemap/sitemap';
import { getProjects } from '@services/project.service';
import { sitemapStatic } from '../../components/sitemap/sitemap.data';

interface SiteMapChild {
  path: string;
  title: string;
}

interface SiteMapSection {
  path: string;
  title: string;
  children?: SiteMapChild[];
}

interface SiteMapProps {
  groupedRoutes: SiteMapSection[];
}

const SiteMap: React.FC<SiteMapProps> = ({ groupedRoutes }) => {
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Sitemap | Agilie',
          description:
            'Discover all pages of our website in one place. Explore our services, expertise areas, and success stories.',
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout>
        <SiteMapComponent groupedRoutes={groupedRoutes} />
      </MainLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  const { data } = await getProjects(0, 1000);
  const sitemap = structuredClone(sitemapStatic);
  const successNode = sitemap.find((n: any) => n.path === '/success-stories');

  if (successNode) {
    successNode.children = data.map((item: any) => ({
      path: `/success-stories/${item.link}`,
      title: item.title || item.name || item.link,
    }));
  }

  return {
    props: {
      groupedRoutes: sitemap,
    },
  };
};

export default SiteMap;
